import React, { useState, useEffect } from "react";
import { FaTimes, FaSave } from "react-icons/fa";
import useBingoStore from "../store";

const SettingsModal = ({ isOpen, onClose }) => {
  const { bingoName, soundOption, animationOption, updateConfig } = useBingoStore();
  
  const [localBingoName, setLocalBingoName] = useState(bingoName);
  const [localSoundOption, setLocalSoundOption] = useState(soundOption);
  const [localAnimationOption, setLocalAnimationOption] = useState(animationOption);

  useEffect(() => {
    if (isOpen) {
      setLocalBingoName(bingoName);
      setLocalSoundOption(soundOption);
      setLocalAnimationOption(animationOption);
    }
  }, [isOpen, bingoName, soundOption, animationOption]);

  const handleSave = () => {
    updateConfig({
      bingoName: localBingoName.trim() || "Bingo",
      soundOption: localSoundOption,
      animationOption: localAnimationOption,
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg m-4 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 flex items-center justify-between">
          <h2 className="text-xl font-bold">Configurações do Bingo</h2>
          <button onClick={onClose} className="text-white hover:text-gray-200 transition-colors">
            <FaTimes className="text-xl" />
          </button>
        </div>

        {/* Form */}
        <div className="p-6 space-y-5">
          {/* Bingo Name */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Nome do Bingo
            </label>
            <input
              type="text"
              value={localBingoName}
              onChange={(e) => setLocalBingoName(e.target.value)}
              placeholder="Ex: Bingo de Natal 2025"
              className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
            />
          </div>

          {/* Sound Option */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Opções de Som
            </label>
            <select
              value={localSoundOption}
              onChange={(e) => setLocalSoundOption(e.target.value)}
              className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
            >
              <option value="none">Sem Som</option>
              <option value="numbers">Somente Números</option>
              <option value="numbers_phrases">Números + Frases Engraçadas</option>
            </select>
          </div>

          {/* Animation Option */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Animação do Sorteio
            </label>
            <select
              value={localAnimationOption}
              onChange={(e) => setLocalAnimationOption(e.target.value)}
              className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
            >
              <option value="3d">Globo 3D</option>
              <option value="simple">Simples</option>
            </select>
          </div>

          {/* Save Button */}
          <button
            onClick={handleSave}
            className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-all flex items-center justify-center gap-2"
          >
            <FaSave />
            Salvar Alterações
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
